export default "__VITE_ASSET__BG5ck72j__"